var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m57.302 227.714c-7.811-7.811-7.811-20.475 0-28.285l117.099-117.099c7.811-7.809 20.474-7.811 28.284 0l73.628 73.628 115.958-115.958h-51.376c-11.046 0-20-8.954-20-20s8.954-20 20-20h99.65c11.225-.006 20.01 9.171 20.01 20v99.66c0 11.046-8.954 20-20 20s-20-8.954-20-20v-51.375l-130.1 130.1c-7.811 7.811-20.474 7.811-28.284 0l-73.628-73.628-102.957 102.957c-7.81 7.811-20.475 7.809-28.284 0zm85.587 146.286v118c0 11.046-8.954 20-20 20h-102.889c-11.046 0-20-8.954-20-20v-118c0-11.046 8.954-20 20-20h102.889c11.046 0 20 8.954 20 20zm-40 20h-62.889v78h62.889zm224.555-96.074v194.074c0 11.046-8.954 20-20 20h-102.888c-11.046 0-20-8.954-20-20v-194.074c0-11.046 8.954-20 20-20h102.889c11.045 0 19.999 8.954 19.999 20zm-40 20h-62.889v154.074h62.889zm224.556-96.073v270.147c0 11.046-8.954 20-20 20h-102.889c-11.046 0-20-8.954-20-20v-270.147c0-11.046 8.954-20 20-20h102.889c11.046 0 20 8.954 20 20zm-40 20h-62.889v230.147h62.889z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.cd4bacd262a519db8c9eff38c0def995.svg";
export { ForwardRef as ReactComponent };